import { AppProviderContext } from '@websrc/App/AppContext'
import {
  checkCookieConsent,
  CookieSettingName,
  listenForCookie,
} from '@websrc/App/Helpers/cookieUtil'
import { useContext, useEffect, useState } from 'react'

export function useHasConsent(consentTypes?: CookieSettingName[], mode: 'any' | 'all' = 'all') {
  const { disableCookies } = useContext(AppProviderContext)
  const [hasConsent, setHasConsent] = useState(checkCookieConsent(consentTypes, mode))

  useEffect(
    () => listenForCookie(() => setHasConsent(checkCookieConsent(consentTypes, mode))),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(consentTypes), mode]
  )

  return !disableCookies && hasConsent
}
